import { Component, Input, OnInit, OnChanges, SimpleChanges, ChangeDetectionStrategy, Inject } from '@angular/core';
import { DEVICE_INFO, DeviceInfo, APP_SETTINGS } from 'angular-engine/modules/ng-express-engine/tokens';

@Component({
    selector: "list",
    templateUrl: "./list.template.html",
    styleUrls: ['./list.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class List implements OnInit {
    @Input() obj_type: string;
    @Input() list: any;
    @Input() fancy: boolean = false;
    @Input() showHeader : boolean = true;
    public isPhone : boolean = false;

    constructor(@Inject(DEVICE_INFO) device: DeviceInfo) {
        this.isPhone = device.isPhone;
    }
    
    ngOnInit(){
        
    }

    ngOnChanges(changes){
        // if( changes.list && changes.list.currentValue && changes.list.currentValue.meta.title == "Latest" ){
        //console.log( changes)
        // }
    }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/list/list.component.ts